module.exports = __webpack_public_path__ + "static/media/case_09.0f803e61.jpg";